import React from "react";

export interface Style {
    _getId(): string;
    _getCss(): string;
}

export type StyleContextValue = {
    styles: { [key: string]: string };
    addStyles: (styles: Style[]) => void;
};

export const StyleContext = React.createContext<StyleContextValue>({
    styles: {},
    addStyles: () => void 0,
});
